import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import RouteConstants from '../routes_constants'
import Loading from '../molecules/loading'
import Text from 'antd/lib/typography/Text'
import MessageConstants from '../message_constants'
import { toast } from 'react-toastify'
import { useGetSessionState } from '../controllers/authentication/clients/auth0'
import { SessionState } from '../controllers/authentication/SessionState'
import { MonitorSingleton } from '../utils/monitor'

export default function NotAuthenticatedWrapper(props: any): JSX.Element {
    const getSessionState = useGetSessionState()
    let navigate = useNavigate()
    const [sessionState, setSessionState] = useState(SessionState.Unknown)
    const [isLoadingSessionState, setIsLoadingSessionState] = useState(true)

    async function loginState() {
        try {
            let state = await getSessionState()
            if (
                state !== SessionState.LoggedOut &&
                state !== SessionState.Unknown
            ) {
                navigate(RouteConstants.HOME, { replace: false })
            } else {
                setSessionState(state)
                setIsLoadingSessionState(false)
            }
        } catch (err) {
            toast(MessageConstants.UNABLE_TO_VALIDATE_LOGIN, { type: 'error' })
            MonitorSingleton.sendException(err)
            setIsLoadingSessionState(false)
        }
    }

    useEffect(() => {
        loginState()
    }, [])

    if (sessionState === SessionState.Unknown) {
        if (isLoadingSessionState) {
            return <Loading />
        } else {
            return <Text>{MessageConstants.UNABLE_TO_VALIDATE_LOGIN}</Text>
        }
    } else if (sessionState === SessionState.LoggedIn) {
        return (
            <Text>
                Already logged in. Redirecting to{' '}
                <Link to={RouteConstants.HOME}>home page</Link>...
            </Text>
        )
    } else {
        return props?.children
    }
}
